module.exports = __webpack_public_path__ + "static/media/Sweety.d71e0de9.png";